/** Panelene som kan poppes ut (utvides etter hvert: kart, chat, PTT, intel …). */
export interface PanelDef {
  id: string;
  title: string;
}

export const POPOUTS = {
  roster: { id: 'roster', title: 'Objektliste' },
  c2: { id: 'c2', title: 'Stridsmeldinger' },
  intel: { id: 'intel', title: 'Etterretning' },
  chat: { id: 'chat', title: 'Chat / TOC' },
  feltveksler: { id: 'feltveksler', title: 'Feltveksler' },
  directory: { id: 'directory', title: 'Kontakter' },
  checklist: { id: 'checklist', title: 'Kapabilitets-sjekkliste' },
  eso: { id: 'eso', title: 'ESO — Styrkeoppbygging' },
  rfi: { id: 'rfi', title: 'RFI / innsamlingsstyring' },
  dispatch: { id: 'dispatch', title: 'Dispatch-kø' },
  perstat: { id: 'perstat', title: 'PERSTAT / sanitet' },
  logistics: { id: 'logistics', title: 'Logistikk / forsyning' },
  admin: { id: 'admin', title: 'Administrasjon' },
  brukere: { id: 'brukere', title: 'Brukere' },
  sensorer: { id: 'sensorer', title: 'Sensorer' },
  personregister: { id: 'personregister', title: 'Personregister' },
  kapabilitetsplanlegger: { id: 'kapabilitetsplanlegger', title: 'Kapabiliteter' },
  orbat: { id: 'orbat', title: 'ORBAT-creator' },
  planprosess: { id: 'planprosess', title: 'Utvikling til Strid' },
  // Radarbilde (SPARK-06): KUN pop-out — det finnes ikke som panel i kartet.
  // Åpnes per node (`&sensor=<IMEI>`), og hver node får sitt eget vindu.
  radarbilde: { id: 'radarbilde', title: 'Radarbilde' },
  // Radar LIVE (RADAR-05): PPI fra mayara-strømmen. Åpnes per radar (`&radar=<id>`).
  radar: { id: 'radar', title: 'Radar' },
  // Kjennemerker (EVA-02): oversikt + kjennemerker av interesse; kamerabildet
  // bak én lesing er KUN pop-out, ett vindu per bilde (`&sti=…`).
  kjennemerker: { id: 'kjennemerker', title: 'Kjennemerker' },
  anprbilde: { id: 'anprbilde', title: 'Kamerabilde' },
  // Kamera fra Åsa (KAMERA-01): Frigate-deteksjonene fra Ivars fartøy, med
  // snapshot. Ett vindu — det er ett kamera.
  kamera: { id: 'kamera', title: 'Kamera (Åsa)' },
  // Levende video fra Åsa (KAMERA-02): hubbens HLS-strøm fra reléet. Ett
  // vindu — det er ett kamera; strømvalg (lav/høy) skjer inne i panelet.
  video: { id: 'video', title: 'Video (Åsa)' },
  // Lidskjalv «Direkte» (OSINT-KAMERA-02): MJPEG fra ett kamera via hubben, per kamera (`&sensor=<id>`).
  lidskjalv: { id: 'lidskjalv', title: 'Lidskjalv' },
  // Kolonner (KOLONNE-05): sammendraget av kjøretøymanifestene (B-012, E7).
  kolonne: { id: 'kolonne', title: 'Kolonner' },
  /** Rent visningskart uten kontroller (vegg-skjerm / andre skjerm). */
  kart: { id: 'kart', title: 'Kart' },
} as const satisfies Record<string, PanelDef>;

export type PopoutId = keyof typeof POPOUTS;

export function erPopoutId(id: string): id is PopoutId {
  return Object.prototype.hasOwnProperty.call(POPOUTS, id);
}

/** Hvilket panel er dette vinduet bedt om å vise? null = full COP. */
export function standalonePanelId(): string | null {
  try {
    const id = new URLSearchParams(location.search).get('panel');
    return id && erPopoutId(id) ? id : null;
  } catch {
    return null;
  }
}

/** En ekstra parameter i pop-out-URL-en (f.eks. `sensor` for radarbildet). null = mangler/tom. */
export function standalonePanelParam(navn: string): string | null {
  try {
    const v = new URLSearchParams(location.search).get(navn)?.trim();
    return v || null;
  } catch {
    return null;
  }
}
